import { useContext } from "react";

import BufferContext from "../../context/materialcapture/BufferContext";

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';

const BufferForm = ({ type }) => {
  const { 
    initialValues, bufferData, setBufferData, formErrors,
  } = useContext(BufferContext);

  return(
    <Grid container spacing={1} mt={1}>
      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Unique ID *"
          name='uniqueId'
          value={bufferData?.uniqueId}
          onChange={e => 
            setBufferData(prev => ({
              ...prev,
              uniqueId: e.target.value
            }))
          }
          helperText={formErrors['uniqueId']}
          error={'uniqueId' in formErrors}
          disabled={type === 'Edit' ? true : false}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <Autocomplete
          value={bufferData?.bufferAcronym}
          onChange={(e, newValue) => 
            setBufferData(prev => ({
              ...prev,
              bufferAcronym: newValue
            }))
          }
          onInputChange={(e, newValue) =>
            setBufferData(prev => ({
              ...prev,
              bufferAcronym: newValue
            }))
          }
          options={initialValues?.bufferAcronymArray}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Buffer Acronym *" 
              placeholder="Type to search Buffer Acronym..." 
              error={'bufferAcronym' in formErrors}
              helperText={formErrors['bufferAcronym']}
            />
          )}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <Autocomplete
          multiple
          freeSolo
          fullWidth
          value={bufferData?.operatorArray || []}
          options={initialValues?.operatorArray || []}
          onChange={(e, newValue) => {
            setBufferData((prev) => ({
              ...prev,
              operatorArray: newValue,
            }));
          }}
          onInputChange={(e, newInputValue, reason) => {
            if (reason === "createOption" && newInputValue.trim()) {
              setBufferData((prev) => ({
                ...prev,
                operatorArray: [
                  ...(prev.operatorArray || []),
                  newInputValue
                ],
              }));
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Operator *"
              placeholder="Type and press Enter..."
              error={"operator" in formErrors}
              helperText={formErrors?.operator}
            />
          )}
        />
      </Grid>

      <Grid item xs={6}>
        <FormControl fullWidth>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label='Date Prepared *'
              name='datePrepared'
              value={bufferData?.datePrepared} 
              onChange={e => 
                setBufferData(prev => ({
                  ...prev,
                  datePrepared: e
                }))
              } 
              maxDate={initialValues?.today}
              renderInput={(params) => 
                <TextField 
                  {...params} 
                  error={Boolean(formErrors['datePrepared'])}
                  helperText={formErrors['datePrepared']}
                />
              }
            />
          </LocalizationProvider>
        </FormControl>
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Target pH *"
          name='targetPH'
          value={bufferData?.targetPH}
          onChange={e => 
            setBufferData(prev => ({
              ...prev,
              targetPH: e.target.value
            }))
          }
          helperText={formErrors['targetPH']}
          error={'targetPH' in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Measured pH *"
          name='measuredPH'
          value={bufferData?.measuredPH}
          onChange={e => 
            setBufferData(prev => ({
              ...prev,
              measuredPH: e.target.value
            }))
          }
          helperText={formErrors['measuredPH']}
          error={'measuredPH' in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Buffer concentration (mmol) *"
          name='bufferConcentration'
          value={bufferData?.bufferConcentration}
          onChange={e => 
            setBufferData(prev => ({
              ...prev,
              bufferConcentration: e.target.value
            }))
          }
          helperText={formErrors['bufferConcentration']}
          error={'bufferConcentration' in formErrors}
          type='number'
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

export default BufferForm;